import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { Heart, FileText, DollarSign, Calendar } from 'lucide-react';
import { TreatmentSupport } from '@/components/customer/TreatmentSupport';

export function TreatmentSupportPage() {
  const { t } = useLanguage();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight mb-2">
          {t('dashboard.customer.dashboard.treatmentSupport.title')}
        </h1>
        <p className="text-muted-foreground">
          {t('dashboard.customer.dashboard.treatmentSupport.description')}
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-[1fr_300px]">
        <div className="space-y-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <TreatmentSupport />
          </motion.div>
        </div>

        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5" />
                {t('dashboard.customer.dashboard.treatmentSupport.form.documents')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <h3 className="font-medium">المستندات المطلوبة</h3>
                <ul className="text-sm text-muted-foreground space-y-2">
                  <li>• تقرير طبي مفصل</li>
                  <li>• تقدير التكلفة من المستشفى</li>
                  <li>• إثبات الدخل</li>
                  <li>• صورة من الهوية</li>
                </ul>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <DollarSign className="h-5 w-5" />
                {t('dashboard.customer.dashboard.treatmentSupport.form.cost')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>متوسط الدعم المقدم</span>
                  <span>50,000 ريال</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>أعلى دعم تم تقديمه</span>
                  <span>100,000 ريال</span>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Calendar className="h-5 w-5" />
                {t('dashboard.customer.dashboard.treatmentSupport.form.title')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>مدة معالجة الطلب</span>
                  <span>5-7 أيام عمل</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>صالح لمدة</span>
                  <span>3 أشهر</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
} 